import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {Product} from '../../../../../../models/product';
import {environment} from '../../../../../../../../environments/environment';

@Component({
  selector: 'app-image-light-box',
  templateUrl: './image-light-box.component.html',
  styleUrls: ['./image-light-box.component.css']
})
export class ImageLightBoxComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: {product: Product , index: number} , private dialog: MatDialog) { }

  hover: any;


  ngOnInit(): void {
  }

  getImageURL() {
    let image_url;

    if (this.data.index === -1) {
       image_url = this.data.product.getImage();

    } else {
      image_url = this.getImageURLByIndex(this.data.index);
    }



    return image_url;

  }

  onNoClick() {

    this.dialog.closeAll();

  }

  getImageURLByIndex(i) {
    // return this.baseImageURL + '/' + this.productInfo[0].media_gallery_entries[i].file;
    //  return this.product.getImage();

    if (this.data.product.media_gallery_entries[0] == undefined) {

    } else {

      return environment.baseCatalogUrl + environment.baseImagePath + this.data.product.media_gallery_entries[i].file;
    }

  }

}
